module.exports = __webpack_public_path__ + "static/media/YM62_2.20e5fe25.jpg";